var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DoughnutChart',{attrs:{"chart-data":_vm.rateAgentOverallChartData}})
}
var staticRenderFns = []

export { render, staticRenderFns }